import React, { useState } from 'react';
import data from '../data';
import GeneralAbility from './GeneralAbility';
import Quade from './Quade'
import InvestigativeAbility from './InvestigativeAbility';
import MutantPowerRow from './MutantPowerRow';



const CreateCharacter = ({
    isEditing, setSelectedView,
    setCharacters, characters, editedCharacter,
    setSelectedCharacter,
    setSavedCharacters
}) => {

    const CreateTabModes = ["INFO", "GENERAL", "INVESTIGATIVE", "POWERS"];

    const AvailablePortraitNames = ["MCBP1", "MCBP2", "MCBP3", "MCBP4"];

    function InitializeGeneralAbilities() {
        var abilityMap = {};
        for (const abilityID in data.generalAbilities) {
            const ability = data.generalAbilities[abilityID];
            abilityMap[ability.id] = ability.freePoints;
        }
        return abilityMap;
    }

    // character data
    const [characterName, setCharacterName]
        = useState(editedCharacter !== null ? editedCharacter.name : "");

    const [description, setDescription]
        = useState(editedCharacter !== null ? editedCharacter.description : "");

    const [portraitName, setPortraitName]
        = useState(editedCharacter !== null && editedCharacter.portraitName !== undefined
            ? editedCharacter.portraitName : AvailablePortraitNames[0]);

    const [numPlayers, setNumPlayers]
        = useState(editedCharacter !== null ? editedCharacter.numPlayers : "2");

    const [isGritty, setIsGritty]
        = useState(editedCharacter !== null ? editedCharacter.isGritty : false);

    const [generalAbilities, setGeneralAbilities]
        = useState(editedCharacter !== null ? editedCharacter.generalAbilities
            : InitializeGeneralAbilities());

    const [investigativeAbilities, setInvestigativeAbilities]
        = useState(editedCharacter !== null ? editedCharacter.investigativeAbilities : {});

    const [powers, setPowers]
        = useState(editedCharacter !== null ? editedCharacter.powers : {});

    const [solidLinks, setSolidLinks]
        = useState(editedCharacter !== null ? editedCharacter.solidLinks : {});

    const [dashedLinks, setDashedLinks]
        = useState(editedCharacter !== null ? editedCharacter.dashedLinks : {});

    const [addedInvestigative, setAddedInvestigative]
        = useState(null);

    const [removedInvestigative, setRemovedInvestigative]
        = useState(null);

    // display mode
    const [selectedMode, setSelectedMode] = useState("INFO");


    function goBack() {
        const displayMode = characters.length > 0
            ? "DISPLAY_CHARACTER" : "MAIN";
        setSelectedView(displayMode);
    }

    function goBackToMain() {
        setSelectedView("MAIN");
    }
 


    //TODO: input validiation

    const populateCharacterData = (updatedCharacter) => {
        updatedCharacter.name = characterName;
        updatedCharacter.description = description;
        updatedCharacter.portraitName = portraitName;
        updatedCharacter.numPlayers = numPlayers;
        updatedCharacter.isGritty = isGritty;
        //TODO: do "list" attributes need to be sorted?
        updatedCharacter.generalAbilities = generalAbilities;
        updatedCharacter.investigativeAbilities = investigativeAbilities;
        updatedCharacter.powers = powers;
        updatedCharacter.solidLinks = solidLinks;
        updatedCharacter.dashedLinks = dashedLinks;
        //pools
        updatedCharacter.generalAbilityPools = {};
        updatedCharacter.generalPowerPools = {};
        updatedCharacter.investigativeAbilityPools = {};
        updatedCharacter.investigativePowerPools = {};
        //pushes
        updatedCharacter.pushes = [
            0, 0
        ];
    };

    // update handles

    const handleCharacterSubmit = (e) => {
        if (isEditing) {
            // edit character
            const editedList = characters.map((oneCharacter) => {
                if (oneCharacter.id === editedCharacter.id) {
                    populateCharacterData(oneCharacter);
                }
                return oneCharacter;
            });
            localStorage.setItem("items", JSON.stringify(editedList));
            setCharacters(editedList);
            setSavedCharacters(editedList);
        } else {
            // add character
            e.preventDefault();
            let characterObject = {
                id: characters.length + 1,
            };
            populateCharacterData(characterObject);
            setCharacters([...characters, characterObject]);
            setSavedCharacters([...characters, characterObject]);
            setSelectedCharacter(characterObject);
        }
        setSelectedView("DISPLAY_CHARACTER");
    };

    const handleChangeName = (e) => {
        setCharacterName(e.target.value);
    };

    const handleChangeDescription = (e) => {
        setDescription(e.target.value);
    };

    // portrait

    function characterPortraitURL() {
        return "MCBP/" + portraitName + ".png";
    }

    function changePortraitLeft() {
        const nameIndex = AvailablePortraitNames.indexOf(portraitName);
        const updatedIndex = nameIndex > 0 ? nameIndex - 1 : AvailablePortraitNames.length - 1;
        setPortraitName(AvailablePortraitNames[updatedIndex]);
    }

    function changePortraitRight() {
        const nameIndex = AvailablePortraitNames.indexOf(portraitName);
        const updatedIndex = nameIndex < AvailablePortraitNames.length - 1 
        ? nameIndex + 1 : 0;
        setPortraitName(AvailablePortraitNames[updatedIndex]);
    }

    // calculating point pools

    const maxPointsGeneral = data.pointPoolGeneral;
    const maxPointsPowers = data.pointPoolMutantPowers;
    //const maxPointsInvestigative = data.pointPoolInvestigative;

    function maxPointsInvestigative() {
        return data.numPlayersToInvestigativePoints[numPlayers];
    }

    function pointsRemainingGeneral() {
        let totalPoints = maxPointsGeneral;
        let pointsSpent = 0;
        const dataAbilities = data.generalAbilities;
        for (const key in dataAbilities) {
            const abilityData = dataAbilities[key];
            const freePoints = abilityData.freePoints;
            totalPoints += freePoints;
            pointsSpent += generalAbilities[abilityData.id];
        }
        return totalPoints - pointsSpent;
    }

    function FindPowerData(key, powersData) {
        for (let powerDataID in powersData) {
            let powerData = powersData[powerDataID];
            if (powerData.id.toString() === key) {
                return powersData[powerDataID];
            }
        }
        return null;
    }

    function pointsRemainingPowers() {
        const powersData = data.mutantPowers;
        let pointsSpent = 0;
        const basePowerCost = 4; // TODO: store in data.js
        const skipCost = 2; //TODO: should store somewhere better, like data.js
        const dashedLinkCost = 4;
        const GRFCost = isGritty ? 0 : 2; //TODO: Should store in data.js
        for (const key in powers) {
            const powerData = FindPowerData(key, powersData);
            if (powers[key] < 0) {
                // we skipped a power
                pointsSpent += skipCost;
            } else if (powers[key] > 0) {
                const powerLevels = powers[key];
                if (powerData.isGRF) {
                    pointsSpent += GRFCost;
                } else if (powerData.isInvestigative) {
                    pointsSpent += 1;
                } else {
                    pointsSpent += basePowerCost;
                    pointsSpent += (powerLevels - 1);
                }
            }
        }
        for (const linkKey in dashedLinks) {
            if (dashedLinks[linkKey] > 0) {
                pointsSpent += dashedLinkCost;
            }
        }
        return maxPointsPowers - pointsSpent;
    }

    function pointsRemainingInvestigative() {
        let pointsSpent = 0;
        for (const key in investigativeAbilities) {
            pointsSpent += investigativeAbilities[key];
        }
        return maxPointsInvestigative() - pointsSpent;
    }

    // loading ui for ability rows

    function GetHighestGeneralAbilityID() {
        let mostPoints = 0;
        let highestAbility = null;
        for (let genID in generalAbilities) {
            const genPoints = generalAbilities[genID];
            if (highestAbility === null || genPoints > mostPoints) {
                highestAbility = genID;
                mostPoints = genPoints;
            }
        }
        return highestAbility;
    }

    function GetSecondHighestGeneralAbilityID() {
        const highestAbilityID = GetHighestGeneralAbilityID();
        if (highestAbilityID === null) {
            return null;
        }
        // same as highest, but the actual highest isn't allowed
        let mostPoints = 0;
        let highestAbility2 = null;
        for (let genID in generalAbilities) {
            if (genID === highestAbilityID) {
                continue;
            }
            const genPoints = generalAbilities[genID];
            if (highestAbility2 === null || genPoints > mostPoints) {
                highestAbility2 = genID;
                mostPoints = genPoints;
            }
        }
        return highestAbility2;
    }

    function GetThirdHighestGeneralAbilityID() {
        const highestAbilityID = GetHighestGeneralAbilityID();
        if (highestAbilityID === null) {
            return null;
        }
        const secondHighestAbilityID = GetSecondHighestGeneralAbilityID();
        if (secondHighestAbilityID === null) {
            return null;
        }

        // need at least 3 equal or higher
        let mostPoints = 0;
        let highestAbility3 = null;
        for (let genID in generalAbilities) {
            if (genID === highestAbilityID || genID === secondHighestAbilityID) {
                continue;
            }
            const genPoints = generalAbilities[genID];
            if (highestAbility3 === null || genPoints > mostPoints) {
                highestAbility3 = genID;
                mostPoints = genPoints;
            }
        }
        return highestAbility3;
    }

    function CanIncrementGeneralAbility(item) {
        const pointsRemaining = pointsRemainingGeneral();
        if (pointsRemaining === 0) {
            return false;
        }
        // this is the highest general ability
        if (GetHighestGeneralAbilityID() === item.id.toString()) {
            const currentPoints = generalAbilities[item.id];
            if (currentPoints === 0) {
                return true;
            }
            const secondThreshold = (currentPoints + 1) / 2;
            const secondHighestID = GetSecondHighestGeneralAbilityID();
            const secondHighestPoints = secondHighestID !== null
                ? generalAbilities[secondHighestID] : 0;
            // no ability can be more than twice the second highest
            return secondHighestPoints >= secondThreshold;
        }
        return true;
    }

    function CanDecrementGeneralAbility(item) {
        const currentPoints = generalAbilities[item.id];
        if (currentPoints === 0) {
            return false;
        }
        // this is the second highest general ability
        if (GetSecondHighestGeneralAbilityID() === item.id.toString()) {
            const highestThreshold = (currentPoints - 1) * 2;
            const highestID = GetHighestGeneralAbilityID();
            const highestPoints = generalAbilities[highestID];
            const thirdHighestID = GetThirdHighestGeneralAbilityID();
            if (thirdHighestID !== null) {
                const thirdHighestPoints = generalAbilities[thirdHighestID];
                // second-highest is a tie, so we don't have to worry about decrementing
                if (thirdHighestPoints === currentPoints) {
                    return true;
                }
            }
            // no ability can be more than twice the second highest
            return highestPoints <= highestThreshold;
        }
        return true;
    }

    function hasLearnedInvestigativeAbility(item) {
        if (addedInvestigative !== null && item.id === addedInvestigative.id) {
            return true;
        }
        return item.id in investigativeAbilities && investigativeAbilities[item.id] > 0;
    }

    function hasNotLearnedInvestigativeAbility(item) {
        if (removedInvestigative !== null && item.id === removedInvestigative.id) {
            return true;
        }
        return !(item.id in investigativeAbilities) || investigativeAbilities[item.id] <= 0;
    }

    function findPower(powerID) {
        for (let a in data.mutantPowers) {
            const dataPower = data.mutantPowers[a];
            if (dataPower.id === parseInt(powerID)) {
                return dataPower;
            }
        }
        return null;
    }

    function isGeneralPower(item) {
        return !(item.isInvestigative || item.isGRF);
    }

    function isInvestigativePower(item) {
        return item.isInvestigative;
    }

    function hasLearnedPower(item) {
        return item.id in powers && powers[item.id] > 0;
    }

    function hasAnyGeneralPowers() {
        for (let powerID in powers) {
            const power = findPower(powerID);
            if (isGeneralPower(power) && hasLearnedPower(power)) {
                return true;
            }
        }
        return false;
    }

    function hasAnyInvestigativePowers() {
        for (let powerID in powers) {
            const power = findPower(powerID);
            if (isInvestigativePower(power) && hasLearnedPower(power)) {
                return true;
            }
        }
        return false;
    }

    // rows

    const generalAbilityRows =  data.generalAbilities.map(
        item => {

            let canIncrement = CanIncrementGeneralAbility(item);
            let canDecrement = CanDecrementGeneralAbility(item);
            return (<GeneralAbility
                key={item.id}
                item={item}
                pointMap={generalAbilities}
                setPointMap={setGeneralAbilities}
                pointsRemaining={pointsRemainingGeneral()}
                canIncrement={canIncrement}
                canDecrement={canDecrement}
            />)
        }
    );

    const learnedInvestigativeRows = data.investigativeAbilities
        .filter(hasLearnedInvestigativeAbility).map(
            item => {
                const isNewRow = addedInvestigative !== null && addedInvestigative.id === item.id;
                return (<InvestigativeAbility
                    key={item.id}
                    item={item}
                    pointMap={investigativeAbilities}
                    setPointMap={setInvestigativeAbilities}
                    pointsRemaining={pointsRemainingInvestigative()}
                    isLearned={true}
                    setAddedInvestigative={setAddedInvestigative}
                    setRemovedInvestigative={setRemovedInvestigative}
                    isNewRow={isNewRow}
                />)
            }
    );

    const notLearnedInvestigativeRows = data.investigativeAbilities
        .filter(hasNotLearnedInvestigativeAbility).map(
            item => {
                const isNewRow = removedInvestigative !== null && removedInvestigative.id === item.id;
                return (<InvestigativeAbility
                    key={item.id}
                    item={item}
                    pointMap={investigativeAbilities}
                    setPointMap={setInvestigativeAbilities}
                    pointsRemaining={pointsRemainingInvestigative()}
                    isLearned={false}
                    setAddedInvestigative={setAddedInvestigative}
                    setRemovedInvestigative={setRemovedInvestigative}
                    isNewRow={isNewRow}
                />)
            }
    );

    const generalPowerRows = data.mutantPowers
        .filter(hasLearnedPower).filter(isGeneralPower).map(
            item => {
                return (<MutantPowerRow
                    key={item.id}
                    item={item}
                    pointMap={powers}
                />)
            }
        );

    const investigativePowerRows = data.mutantPowers
        .filter(hasLearnedPower).filter(isInvestigativePower).map(
            item => {
                return (<MutantPowerRow
                    key={item.id}
                    item={item}
                    pointMap={powers}
                />)
            }
        );

    // navigation

        const activateButton = (buttonID) => {
            const btns = document.getElementsByClassName("button-selected");
            while (btns.length) {
                btns[0].classList.remove("button-selected");
            }
            const selectBtn = document.getElementById(buttonID);
            selectBtn.classList.add("button-selected");
    }

    function navTab(tabKey) {
        setAddedInvestigative(null);
        setRemovedInvestigative(null);
        switch (tabKey) {
            case "INFO":
                navInfo();
                break;
            case "GENERAL":
                navGeneral();
                break;
            case "INVESTIGATIVE":
                navInvestigative();
                break;
            case "POWERS":
                navPowers();
                break;
            default:
                break;
        }
    }

    function navInfo() {
        setAddedInvestigative(null);
        setRemovedInvestigative(null);
            setSelectedMode("INFO");
            activateButton("nav-btn-info");
        }

    function navGeneral() {
        setAddedInvestigative(null);
        setRemovedInvestigative(null);
            setSelectedMode("GENERAL");
            activateButton("nav-btn-general");
        }

    function navPowers() {
        setAddedInvestigative(null);
        setRemovedInvestigative(null);
            setSelectedMode("POWERS");
            activateButton("nav-btn-powers");
        }

    function navInvestigative() {
        setAddedInvestigative(null);
        setRemovedInvestigative(null);
            setSelectedMode("INVESTIGATIVE");
            activateButton("nav-btn-investigative");
    }

    // navigation (back and forth)

    const navPrevious = (e) => {
        e.preventDefault();
        const index = CreateTabModes.indexOf(selectedMode);
        if (index === 0) {
            goBackToMain();
        } else {
            navTab(CreateTabModes[index - 1]);
        }
    }

    const navNext = (e) => {
        e.preventDefault();
        const index = CreateTabModes.indexOf(selectedMode);
        if (index === CreateTabModes.length - 1) {
            handleCharacterSubmit(e);
        } else {
            navTab(CreateTabModes[index + 1]);
        }
    }

    function PrevButtonName() {
        return selectedMode === "INFO" ? "BACK" : "PREVIOUS";
    }

    function NextButtonName() {
        return selectedMode === "POWERS" ? "FINISH" : "NEXT";
    }

    // select actions

    const onChangeNumPlayers = (e) => {
        const val = e.target.value;
        setNumPlayers(val);
    }

    const handleGrittyCheckbox = (e) => {
        setIsGritty(!isGritty);
    }

        return (
            <div className="Create-character">
                <div className="App-blackbar" />
                <nav style={{ display: "flex", justifyContent: "center" }}>
                    <ul className="App-nav-tabs" style={{marginLeft:"12px"}} >
                        <li className="App-nav-tab Create-edit-tab-info">
                            <div className="App-tab-border" />
                            <button id="nav-btn-info"
                                className="button-selected"
                                type="button"
                                onClick={navInfo}>INFO
                            </button>
                        </li>
                        <li className="App-nav-tab Create-edit-tab-general">
                            <div className="App-tab-border" />
                            <button id="nav-btn-general"
                                className="button-selected"
                                type="button"
                                onClick={navGeneral}>GENERAL ABILITIES
                            </button>
                        </li>
                        <li className="App-nav-tab Create-edit-tab-investigative"
                            style={{ marginLeft: "-4%", marginRight: "-4%" }}>
                            <div className="App-tab-border" />
                            <button id="nav-btn-investigative"
                                type="button"
                                onClick={navInvestigative}>INVESTIGATIVE
                            </button>
                        </li>
                        <li className="App-nav-tab Create-edit-tab-quade" >
                            <div className="App-tab-border" />
                            <button id="nav-btn-powers"
                                type="button"
                                onClick={navPowers}>QUADE DIAGRAM
                            </button>
                        </li>
                    </ul>
                </nav>
                <form onSubmit={handleCharacterSubmit}>
                {selectedMode === "INFO" && (
                        <div className="App--info-box">
                            <div className="App-header-character-infobox">
                                <div className="App-header-charactername">
                                    <div style={{
                                        position: "relative",
                                        width: "220px", height: "220px",
                                        margin: "10px"
                                    }}>
                                    <div className="App-header-characterpicture-edit"
                                            style={{
                                                backgroundImage: `url(${process.env.PUBLIC_URL
                                                    + '/' + characterPortraitURL()})`
                                            }}
                                    >
                                        
                                        </div>
                                        <div className="App-header-characterpicture-button-box">
                                            <button
                                                className="App-header-characterpicture-button"
                                                fontWeight="bold"
                                                type="button"
                                                onClick={changePortraitLeft}
                                                style={{ marginLeft: "20px", marginTop: "8px" }}
                                            >
                                                {"<"}
                                            </button>
                                            <div className="Character-picture-label">PORTRAIT</div>
                                            <button
                                                className="App-header-characterpicture-button"
                                                fontWeight="bold"
                                                type="button"
                                                onClick={changePortraitRight}
                                                style={{ marginRight: "20px", marginTop: "8px" }}
                                            >
                                                {">"}
                                            </button>

                                        </div>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "row" }} >
                                        <img src="./Pencil.png"
                                            width="40px" alt="Edit" top="10px"
                                            height="40px"
                                            style={{
                                                objectFit: "contain",
                                                marginTop:"20px"
                                            }}
                                            ></img>
                                    <input
                                            type="text"
                                            value={characterName}
                                            name="characterName"
                                            onChange={handleChangeName}
                                            className="App-header-characternametext"
                                            maxLength="20"
                                        >
                                        </input>
                                    </div>
                                </div>
                                <div className="App-header-characterinfo">
                                    <div className="App-header-characterdescription">
                                        <div className="App-header-characterdescription-header">
                                            Character Description
                                        </div>
                                        <div className="App-header-characterdescription-whitebar" />
                                        <div className="App-header-characterdescription-description">
                                            <img src="./Pencil.png"
                                                width="20px" alt="Edit" top="10px"
                                                height="20px"
                                                style={{
                                                    objectFit: "contain",
                                                    marginTop: "6px",
                                                    marginLeft:"6px",
                                                    position: "absolute"
                                                }}
                                            ></img>
                                            <textarea
                                                className="App-header-characterdescription-description-text"
                                                value={description}
                                                name="characterDescription"
                                                onChange={handleChangeDescription}
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}> 
                            <div className="Num-players-select-box">
                                PLAYERS{" "}
                                <div className="Radio-button-group">
                                    <label className="Radio-label">
                                        <input
                                            type="radio"
                                            value="2"
                                            checked={numPlayers === "2"}
                                            onChange={onChangeNumPlayers}
                                        />
                                        2
                                    </label>
                                    <label className="Radio-label">
                                        <input
                                            type="radio"
                                            value="3"
                                            checked={numPlayers === "3"}
                                            onChange={onChangeNumPlayers}
                                        />
                                        3
                                    </label>
                                    <label className="Radio-label">
                                        <input
                                            type="radio"
                                            value="4"
                                            checked={numPlayers === "4"}
                                            onChange={onChangeNumPlayers}
                                        />
                                        4
                                    </label>
                                        <label className="Radio-label">
                                        <input
                                            type="radio"
                                            value="5+"
                                            checked={numPlayers === "5+"}
                                            onChange={onChangeNumPlayers}
                                        />
                                        5+
                                    </label>

                                </div>
                                </div>
                                <div className="Select-gritty-box Black-container">
                                    Gritty Mode {" "}
                                    <div className="Basic-checkbox-container">
                                    <input
                                    type="checkbox"
                                    id="checkbox"
                                    checked={isGritty}
                                    onChange={handleGrittyCheckbox}
                                    />
                                        <span
                                            onClick={handleGrittyCheckbox }
                                            className="Basic-checkbox"></span>
                                    </div>
                                </div>
                            </div>
                </div>
                 )}        
                    {selectedMode === "GENERAL" && (
                        <div style={{ display: "flex", flexDirection:"column", alignItems:"center", position:"relative" }}>
                            <div className="App--box-header-point-pool-outer">
                            <div className="App--box-header-point-pool Symmetrical-topflare">
                            GENERAL ABILITY POINTS
                        </div>
                        <div className="App--point-pool-box">
                            {pointsRemainingGeneral()}
                            </div>
                            </div>
                            <div className="App--box-header-general-ability-list 
                                Symmetrical-topflare">
                                LEARNED ABILITIES
                            </div>
                            <div className="Tooltip-container">
                            <div className="Tooltip">
                                ?
                                <span className="Tooltip-text Tooltip-top">
                                        Use the - and + buttons to adjust your ability ranks.
                                        <br />You automatically get 1 point in Health and 1 in Composure.
                                        <br />Your highest-ranked ability cannot have a rank twice as high as your second-highest ranked ability.
                                </span>
                                </div>
                            </div>
                            <div className="App--section-general-ability-list">
                            {generalAbilityRows}
                            </div>
                    </div>)}
                {selectedMode === "POWERS" && (
                        <div className="Powers--container">
                            <div className="App--box-header-point-pool-outer"
                                style={{marginBottom:"10px"} }>
                            <div className="App--box-header-point-pool Symmetrical-topflare">
                                MUTANT POWER POINTS
                            </div>
                            <div className="App--point-pool-box">{pointsRemainingPowers()}
                                </div>
                            </div>
                            
                            <Quade
                                powerData={data.mutantPowers}
                                linkData={data.mutantPowerLinks}
                                isEditable={true}
                                pointsRemaining={pointsRemainingPowers()}
                                powers={powers}
                                setPowers={setPowers}
                                solidLinks={solidLinks}
                                setSolidLinks={setSolidLinks}
                                dashedLinks={dashedLinks}
                                setDashedLinks={setDashedLinks}
                            />
                            <div className="Create-powers-list-section">
                                <div className="Create-powers-list-general">
                                    {
                                        hasAnyGeneralPowers() && (
                                            <div>
                                                <div className="Symmetrical-topflare"
                                                    style={{ marginRight: "4px" }}
                                                >
                                                    GENERAL POWERS
                                                </div>
                                                <div style={{
                                                    marginRight: "4px",
                                                    border: "solid 3px"
                                                }}>
                                                    {generalPowerRows}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="Create-powers-list-investigative">
                                    {
                                        hasAnyInvestigativePowers() && (
                                            <div>
                                                <div className="Symmetrical-topflare"
                                                    style={{ marginLeft: "4px" }}
                                                >
                                                    INVESTIGATIVE POWERS
                                                </div>
                                                <div style={{
                                                    marginLeft: "4px",
                                                    border: "solid 3px"
                                                }}>
                                                    {investigativePowerRows}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                    </div>)}
                    {selectedMode === "INVESTIGATIVE" && (
                        <div className="App--create-investigative-box">
                            <div className="App--box-header-point-pool-outer">
                                <div className="App--box-header-point-pool Symmetrical-topflare">
                                    INVESTIGATIVE ABILITY POINTS
                                </div>
                                <div className="App--point-pool-box">
                                    {pointsRemainingInvestigative()}
                                </div>
                            </div>
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginTop: "8px"
                            }}>
                                <div className="App--box-investigative-list">
                                    <div className="App--box-header-investigative-list Symmetrical-topflare">
                                        LEARNED ABILITIES
                                    </div>
                                    <div className="App--box-contents-investigative-list">
                                        {learnedInvestigativeRows}
                                    </div>
                                </div>
                                <div style={{ flex: "1", width: "10px" }} />
                                <div className="App--box-investigative-list">
                                    <div className="App--box-header-investigative-list Symmetrical-topflare">
                                    INVESTIGATIVE POOL
                                    </div>
                                    <div className="App--box-contents-investigative-list">
                                        {notLearnedInvestigativeRows}
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: "2px"
                }}>
                        
                        
                    </div>
                    <div className="App--create-bottom-bar">
                        <button
                            onClick={navPrevious}
                            className="App--create-bottom-bar-button">
                            {PrevButtonName()}
                        </button>
                    <button
                            className="App--create-bottom-bar-button"
                        type="submit">
                        SAVE & EXIT
                        </button>
                        <button
                            onClick={navNext}
                            className="App--create-bottom-bar-button">
                            {NextButtonName()}
                        </button>
                    </div>
            </form>
        </div>
    );
}

export default CreateCharacter;